// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__MIEkv","content":"main_content__O+z0O"};